var _circle, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8418,
    cy: 39.8398,
    r: 38.2018,
    fill: "white",
    stroke: "white",
    strokeWidth: 2.4036
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "url(#paint0_linear_6278_4505)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2057 34.2867L33.3219 32.7293C33.371 32.0699 33.9428 31.5901 34.597 31.6594L48.201 33.0221C48.859 33.0882 49.3512 33.6747 49.2988 34.3303L48.2817 47.9682C48.2325 48.6276 47.6608 49.1074 47.0066 49.0381L45.4527 48.8821C44.7877 48.8153 44.2933 48.2108 44.357 47.5458L45.172 39.3122L34.3617 48.3831C33.8615 48.8029 33.1125 48.7277 32.6818 48.2144L31.6456 46.9795C31.2149 46.4662 31.2709 45.7156 31.7712 45.2958L42.5814 36.2249L34.3315 35.5978C33.6617 35.5482 33.1522 34.9563 33.2057 34.2867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6278_4505",
    x1: 72.0081,
    y1: 72,
    x2: 8.00811,
    y2: 7.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8743"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateArrow);
export default __webpack_public_path__ + "static/media/navigateArrow.c1ae86cb6eaf14e453d1cd7b510bdc90.svg";
export { ForwardRef as ReactComponent };